import { render, staticRenderFns } from "./SetsRatesModal.vue?vue&type=template&id=09397580&"
import script from "./SetsRatesModal.vue?vue&type=script&lang=js&"
export * from "./SetsRatesModal.vue?vue&type=script&lang=js&"
import style0 from "./SetsRatesModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports